// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Uploader-space1-TjgcK {
	margin-bottom: 6px !important;
}

.Uploader-space2-Zhh8e {
	margin-bottom: 12px !important;
}

.Uploader-space3-AHtOD {
	margin-bottom: 18px !important;
}

.Uploader-space4-GLSpp {
	margin-bottom: 24px !important;
}

.Uploader-space5-TOR4Y {
	margin-bottom: 30px !important;
}

.Uploader-space6-KWswL {
	margin-bottom: 36px !important;
}

.Uploader-space7-WJRvP {
	margin-bottom: 42px !important;
}

.Uploader-spaceTop8-KHSqj {
	margin-bottom: 48px !important;
}

.Uploader-spaceTop1-B8J8j {
	margin-top: 6px !important;
}

.Uploader-spaceTop2-mIKk0 {
	margin-top: 12px !important;
}

.Uploader-spaceTop3-r6jzD {
	margin-top: 18px !important;
}

.Uploader-spaceTop4-IZgdv {
	margin-top: 24px !important;
}

.Uploader-spaceTop5-Rar90 {
	margin-top: 30px !important;
}

.Uploader-spaceTop6-ZiP9e {
	margin-top: 36px !important;
}

.Uploader-spaceTop7-WMPbK {
	margin-top: 42px !important;
}

.Uploader-spaceTop8-KHSqj {
	margin-top: 48px !important;
}

.Uploader-noMargin-gLlSf {
	margin: 0px !important;
}

.Uploader-padding1-KmBmF {
	padding-bottom: 6px !important;
}

.Uploader-padding2-dboWB {
	padding-bottom: 12px !important;
}

.Uploader-padding3-LPvZw {
	padding-bottom: 18px !important;
}

.Uploader-padding4-thVrA {
	padding-bottom: 24px !important;
}

.Uploader-padding5-Enlk2 {
	padding-bottom: 30px !important;
}

.Uploader-padding6-IFFnm {
	padding-bottom: 36px !important;
}

.Uploader-padding7-Onhfu {
	padding-bottom: 42px !important;
}

.Uploader-paddingTop1-UgkEN {
	padding-top: 6px !important;
}

.Uploader-paddingTop2-ZpyTb {
	padding-top: 12px !important;
}

.Uploader-paddingTop3-OFjwN {
	padding-top: 18px !important;
}

.Uploader-paddingTop4-lAgZg {
	padding-top: 24px !important;
}

.Uploader-paddingTop5-bho6b {
	padding-top: 30px !important;
}

.Uploader-paddingTop6-ohJcD {
	padding-top: 36px !important;
}

.Uploader-paddingTop7-zVoRg {
	padding-top: 42px !important;
}

.Uploader-noPadding-wB06v {
	padding: 0px !important;
}

.Uploader-textBold-gwX6M {
	font-weight: 500 !important;
}

.Uploader-textBolder-UJwus {
	font-weight: 700 !important;
}

.Uploader-textNormal-RQUkZ {
	font-weight: normal !important;
}

.Uploader-spaceBottom20-ElY5g {
	margin-bottom: 20px;
}

.Uploader-spaceBottom10-Dgh8Q {
	margin-bottom: 10px;
}

.Uploader-marginNone-VoCqm {
	margin: 0;
}

.Uploader-spaceBottom15-YOzj1 {
	margin-bottom: 15px;
}

.Uploader-marginTopNone-IH4H4 {
	margin-top: 0;
}

.Uploader-spaceTop11-_jqSb {
	margin-top: 11px;
}

.Uploader-spaceTop21-G6OOw {
	margin-top: 21px;
}

.Uploader-spaceTop20-cBEIA {
	margin-top: 20px;
}

.Uploader-spaceTop10-losJW {
	margin-top: 10px;
}

/*New Design Text Colors */

.Uploader-textDarkBlue-RD7on {
	color: rgb(20, 39, 94) !important;
}

.Uploader-textLightBlue-_TOnq {
	color: rgb(57, 87, 106) !important;
}

.Uploader-textLightSandleGreen-URtTK {
	color: rgb(76, 86, 41) !important;
}

.Uploader-textLightBrown-KbCqS {
	color: rgb(115, 79, 33) !important;
}

.Uploader-textMediumMaroon-Zl3AD {
	color: rgb(87, 37, 51) !important;
}

.Uploader-textBrown-bXVNA {
	color: rgb(160, 47, 24) !important;
}

.Uploader-textMaroon-BPnsI {
	color: rgb(155, 49, 67) !important;
}

.Uploader-textDarkBrown-sr3BV {
	color: rgb(83, 18, 16) !important;
}

.Uploader-textMediumBrown-LBbfY {
	color: rgb(142, 28, 10) !important;
}

.Uploader-textSkyBlue-oPM8A {
	color: rgb(37, 117, 141) !important;
}

.Uploader-textGray-zWvbr {
	color: rgb(77, 65, 51) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `Uploader-space1-TjgcK`,
	"space2": `Uploader-space2-Zhh8e`,
	"space3": `Uploader-space3-AHtOD`,
	"space4": `Uploader-space4-GLSpp`,
	"space5": `Uploader-space5-TOR4Y`,
	"space6": `Uploader-space6-KWswL`,
	"space7": `Uploader-space7-WJRvP`,
	"spaceTop8": `Uploader-spaceTop8-KHSqj`,
	"spaceTop1": `Uploader-spaceTop1-B8J8j`,
	"spaceTop2": `Uploader-spaceTop2-mIKk0`,
	"spaceTop3": `Uploader-spaceTop3-r6jzD`,
	"spaceTop4": `Uploader-spaceTop4-IZgdv`,
	"spaceTop5": `Uploader-spaceTop5-Rar90`,
	"spaceTop6": `Uploader-spaceTop6-ZiP9e`,
	"spaceTop7": `Uploader-spaceTop7-WMPbK`,
	"noMargin": `Uploader-noMargin-gLlSf`,
	"padding1": `Uploader-padding1-KmBmF`,
	"padding2": `Uploader-padding2-dboWB`,
	"padding3": `Uploader-padding3-LPvZw`,
	"padding4": `Uploader-padding4-thVrA`,
	"padding5": `Uploader-padding5-Enlk2`,
	"padding6": `Uploader-padding6-IFFnm`,
	"padding7": `Uploader-padding7-Onhfu`,
	"paddingTop1": `Uploader-paddingTop1-UgkEN`,
	"paddingTop2": `Uploader-paddingTop2-ZpyTb`,
	"paddingTop3": `Uploader-paddingTop3-OFjwN`,
	"paddingTop4": `Uploader-paddingTop4-lAgZg`,
	"paddingTop5": `Uploader-paddingTop5-bho6b`,
	"paddingTop6": `Uploader-paddingTop6-ohJcD`,
	"paddingTop7": `Uploader-paddingTop7-zVoRg`,
	"noPadding": `Uploader-noPadding-wB06v`,
	"textBold": `Uploader-textBold-gwX6M`,
	"textBolder": `Uploader-textBolder-UJwus`,
	"textNormal": `Uploader-textNormal-RQUkZ`,
	"spaceBottom20": `Uploader-spaceBottom20-ElY5g`,
	"spaceBottom10": `Uploader-spaceBottom10-Dgh8Q`,
	"marginNone": `Uploader-marginNone-VoCqm`,
	"spaceBottom15": `Uploader-spaceBottom15-YOzj1`,
	"marginTopNone": `Uploader-marginTopNone-IH4H4`,
	"spaceTop11": `Uploader-spaceTop11-_jqSb`,
	"spaceTop21": `Uploader-spaceTop21-G6OOw`,
	"spaceTop20": `Uploader-spaceTop20-cBEIA`,
	"spaceTop10": `Uploader-spaceTop10-losJW`,
	"textDarkBlue": `Uploader-textDarkBlue-RD7on`,
	"textLightBlue": `Uploader-textLightBlue-_TOnq`,
	"textLightSandleGreen": `Uploader-textLightSandleGreen-URtTK`,
	"textLightBrown": `Uploader-textLightBrown-KbCqS`,
	"textMediumMaroon": `Uploader-textMediumMaroon-Zl3AD`,
	"textBrown": `Uploader-textBrown-bXVNA`,
	"textMaroon": `Uploader-textMaroon-BPnsI`,
	"textDarkBrown": `Uploader-textDarkBrown-sr3BV`,
	"textMediumBrown": `Uploader-textMediumBrown-LBbfY`,
	"textSkyBlue": `Uploader-textSkyBlue-oPM8A`,
	"textGray": `Uploader-textGray-zWvbr`
};
module.exports = ___CSS_LOADER_EXPORT___;
